import './utils/errorHandler';
import Vue from 'vue';
import router, {
  PATH_TO_REDIRECT_IF_LOGGED,
} from './routers';
import store from './store/store';
import {UPDATE_USER_INFO} from './store/mutationTypes';

import './utils/filters';
import './utils/plugins';
import './utils/injections';
import './utils/social';
import './utils/directives';
import './assets/css/main.scss';
import LoaderComponent from './components/LoaderComponent';
import {
  DEFAULT_LANGUAGE,
  LANGUAGES,
  URL_QUERIES,
} from './const';
import VisaicV3Analytics
  from '@/components/base-components/Analytics/VisaicV3Analytics';
import {
  GET_API_KEY,
  GET_CHANNEL_KEY,
  GET_ALL_PARTICIPANTS,
  GET_CHANNEL_STATIC_DATA,
  GET_GEO_DATA,
  GET_PROFILE,
  AUTH_CHECK,
} from '@/store/actionTypes';
import ErrorReloadScreen from '@/views/ErrorReloadScreen.vue';
import {HOME_TYPES_NAMES} from '@/ui_builder/homeTypes';
import {
  getBuilderBlockRawData,
  getNameFromBuilderBlock,
} from '@/utils/helpers';
import {PAGES_PATHS} from '@/pages';

Vue.i18n.add(DEFAULT_LANGUAGE, LANGUAGES[DEFAULT_LANGUAGE]);
Vue.i18n.set(DEFAULT_LANGUAGE);

const needParticipantInitRequest = (new URLSearchParams(location.search)).
    has(URL_QUERIES.PARTICIPANT);

new Vue({
  el: '#app',
  store,
  router,
  components: {LoaderComponent, ErrorReloadScreen},
  template: `
      <error-reload-screen :class="{'d-none' : !app}">
          <component v-if="app" :is="app"/>
      </error-reload-screen>`,
  data() {
    return {
      app: false,
    };
  },
  watch: {
    app() {
      if (this.app) {
        document.getElementById('splash_loader').classList.add('out');
        setTimeout(() => {
          document.getElementById('splash_loader').remove();
        }, 500);
      }
    },
  },
  mounted() {
    store.dispatch(GET_CHANNEL_KEY).then(() => store.dispatch(
        GET_API_KEY,
        {channel_key: Vue.$storage.get('channel_key')},
    )).then(() => Promise.allSettled([
      store.dispatch(GET_CHANNEL_STATIC_DATA).then((hasParticipants) => {
        if (!needParticipantInitRequest && hasParticipants) {
          store.dispatch(GET_ALL_PARTICIPANTS);
        }
      }),
      needParticipantInitRequest && store.dispatch(GET_ALL_PARTICIPANTS),
      store.dispatch(AUTH_CHECK).then(() => {
        return store.dispatch(GET_PROFILE).then(async () => {
          const isTempPass = store?.state?.auth?.user?.temporary_password;

          router.currentRoute.meta.disabledForAuth &&
          await router.replace(isTempPass? PAGES_PATHS.PROFILE_EDIT : PATH_TO_REDIRECT_IF_LOGGED);
        });
      }).catch(() => store.dispatch(GET_GEO_DATA)),
    ])).catch((err) => {
      store.commit(UPDATE_USER_INFO, null);
      return err;
    }).finally(async () => {
      // add aliases to routes to imitate custom pages with dynamics routes
      [
        HOME_TYPES_NAMES.PARTICIPANTS,
        HOME_TYPES_NAMES.PARTICIPANT_GROUPS,
        HOME_TYPES_NAMES.EVENT_CATEGORIES,
        HOME_TYPES_NAMES.LOCATIONS,
      ].forEach((type) => {
        const newPart = router.options.routes.find(({name}) => name === type);
        const block = getBuilderBlockRawData('home_blocks', type);
        const alias = getNameFromBuilderBlock(block);
        if (alias) {
          newPart.alias = [`/${alias}`];
          newPart.meta.pageTitle = block.customName;
          router.addRoute(newPart);
        }
      });

      const newRoutersArr = [
        ...(store.getters.getChannelRoute || []),
        {
          path: '*',
          redirect: '/404',
        },
      ];
      newRoutersArr.forEach((route) => router.addRoute(route));
      
      this.app = await import('./league/LeagueApp').then((m) => m.default);
      
      VisaicV3Analytics.init({
        userId: store.state.auth?.user?.id,
        profile: store.state.channel?.settings?.['yare-analytics']?.['yare-analytics-key'],
        apiKey: Vue.$storage.get('api_key'),
      });
    });
  },
});
